/* START_MODULE_CONTRACT
 * PURPOSE: Frontend model: Employee.
 * SCOPE: DTO mapping / constants.
 * DEPENDS: M-FE-API
 * LINKS: M-FE-API
 * ROLE: TYPES
 * END_MODULE_CONTRACT
 *
 * START_MODULE_MAP
 * Employee - Frontend model: Employee.
 * END_MODULE_MAP
 *
 * START_CHANGE_SUMMARY
 * LAST_CHANGE: 2026-07-02 - GRACE coverage: реальный class-контракт и парный END_CLASS.
 * END_CHANGE_SUMMARY
 */

import EmployeeAbsence from './EmployeeAbsence';

/* START_CLASS_Employee */
/* START_CONTRACT: Employee
 * PURPOSE: Клиентская модель сотрудника с ролью, загрузкой и отсутствиями.
 * INPUTS: { id, projectId, name, projectRoleId, projectRoleName, projectRoleWorkloadPercent, createdAt, absences }.
 * OUTPUTS: экземпляр Employee; getRoleLabel().
 * SIDE_EFFECTS: нет.
 * LINKS: M-FE-API, M-EMPLOYEE
 * END_CONTRACT: Employee
 */
export default class Employee {
  constructor({
    id,
    projectId,
    name,
    projectRoleId,
    projectRoleName,
    projectRoleWorkloadPercent,
    createdAt,
    absences,
  }) {
    this.id = id;
    this.projectId = projectId;
    this.name = name ?? '';
    this.projectRoleId = projectRoleId;
    this.projectRoleName = projectRoleName ?? '';
    this.projectRoleWorkloadPercent = projectRoleWorkloadPercent ?? 100;
    this.createdAt = createdAt ? new Date(createdAt) : null;
    this.absences = (absences ?? []).map(EmployeeAbsence.fromResponse);
  }

  getRoleLabel() {
    return this.projectRoleName || '';
  }

  static fromResponse(data) {
    return new Employee(data);
  }
}
/* END_CLASS_Employee */
